import React, { ReactNode } from 'react'
import { Stack } from '@awazevr/design-system.components.stack'
import { Text } from '@awazevr/design-system.components.text'
import { Link } from '@awazevr/design-system.components.link'
import { ContentfulData } from '../../../utils/contentful'
import { usePBStore } from '../../store/provider'
import { selectBrand } from '../../store/selectors'

interface IProps {
  data: ContentfulData
}

const TermsOfService = ({ data }: IProps): ReactNode => {
  const { labels, links } = data
  const brand = usePBStore(selectBrand)

  return (
    <Stack spacing={4} isHorizontal wrap="wrap" fullWidth>
      <Text sizes={100}>
        {labels['label_policy'] ?? ''}
        {labels['label_aggred_on'] ?? ''}
        <Link
          href={
            links[`link_terms_${brand}`]?.href ??
            'https://www.cottages.com/legal/terms-of-use'
          }
          openInNewTab
          colourScheme="brand-link"
          testId="link-terms-of-use-test-id"
        >
          {links[`link_terms_${brand}`]?.title ?? 'Terms of use'}
        </Link>
        {labels['label_and']}
        <Link
          href={
            links[`link_policy_${brand}`]?.href ??
            'https://www.cottages.com/legal/privacy-notice'
          }
          openInNewTab
          colourScheme="brand-link"
          testId="link-privacy-policy-test-id"
        >
          {links[`link_policy_${brand}`]?.title ?? 'Privacy policy'}
        </Link>
      </Text>
    </Stack>
  )
}

export default TermsOfService
